import { render } from "./TheFooter.vue?vue&type=template&id=405319bc&scoped=true"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=405319bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-405319bc"

export default script